import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

class StatsCentreLayout extends View {

	get template() {
		return template;
	}

	get className() {
		return "stats-centre-layout";
	}

	regions() {
		return {
			content:     '.content',
			sidebar:     '.sidebar'
		};
	}

}

export default StatsCentreLayout;